import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { API } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogleLogin = (path = "/dashboard") => {
  const redirectUrl = window.location.origin + path;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const useOwnerAuth = () => {
  const location = useLocation();
  const [user, setUser] = useState(location.state?.user || null);
  const [auth, setAuth] = useState(location.state?.user ? true : null);
  const [forbidden, setForbidden] = useState(false);

  useEffect(() => {
    if (location.state?.user) {
      setUser(location.state.user);
      setAuth(true);
      return;
    }
    if (window.location.hash?.includes("session_id=")) return;
    const check = async () => {
      try {
        const res = await fetch(`${API}/auth/me`, { credentials: "include" });
        if (!res.ok) throw new Error();
        setUser(await res.json());
        setAuth(true);
      } catch {
        setAuth(false);
      }
    };
    check();
  }, [location.state]);

  return { user, auth, forbidden, setForbidden };
};
